import { render, staticRenderFns } from "./VenueSubscriptionListItem.vue?vue&type=template&id=10b64d39&scoped=true&"
import script from "./VenueSubscriptionListItem.vue?vue&type=script&lang=ts&"
export * from "./VenueSubscriptionListItem.vue?vue&type=script&lang=ts&"
import style0 from "./VenueSubscriptionListItem.vue?vue&type=style&index=0&id=10b64d39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b64d39",
  null
  
)

export default component.exports